import { render, staticRenderFns } from "./Learning.vue?vue&type=template&id=3fc3925c&scoped=true&"
var script = {}
import style0 from "./Learning.vue?vue&type=style&index=0&id=3fc3925c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc3925c",
  null
  
)

export default component.exports